import { render, staticRenderFns } from "./EditarOpinion.vue?vue&type=template&id=70798bc0&"
import script from "./EditarOpinion.vue?vue&type=script&lang=js&"
export * from "./EditarOpinion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports